import { useMemo } from "react";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from "react-router-dom";
import WebsiteIndex from "./WebsiteIndex";
import BlogIndex from "./Blog/BlogIndex";
import PostIndex from "./Post/PostIndex";
import RosterIndex from "./Roster/RosterIndex";
import AreaPagesIndex from "./AreaPages/AreaPagesIndex";
import NewAreaPage from "./AreaPages/NewAreaPage";
import AreaPageEditor from "./AreaPages/AreaPageEditor";

const WebsiteApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<WebsiteIndex />}>
        <Route index element={<Navigate to="blog" replace />} />
        <Route path="blog" element={<BlogIndex />} />
        <Route path="area_pages" element={<AreaPagesIndex />} />
        <Route path="area_pages/new" element={<NewAreaPage />} />
        <Route path="area_pages/:uuid" element={<AreaPageEditor />} />
        <Route path="roster" element={<RosterIndex />} />
        <Route path="post/:uuid" element={<PostIndex />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>,
    ),
    { basename: "/website" },
  );

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};

export default WebsiteApp;
